"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pfComponentLibrary = require("@pf-loan-funnel/pf-component-library");
require("./styles.scss");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BLOCK_CLASS = 'pf-select-plan-form';
var bem = (0, _pfComponentLibrary.klass)(BLOCK_CLASS);
var subTextMapping = new Map([['PRP', ['Subject to final credit approval.']], ['NI', ['Subject to final credit approval.', 'Plan options may vary by provider.']]]);
var renderSubText = function renderSubText(selectedOffer) {
  if (!selectedOffer) return null;
  var _selectedOffer$split = selectedOffer.split('-'),
    _selectedOffer$split2 = (0, _slicedToArray2.default)(_selectedOffer$split, 1),
    product = _selectedOffer$split2[0];
  var texts = subTextMapping.get(product.toUpperCase());
  if (!texts) return null;
  return texts.map(function (text) {
    return /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Text, {
      className: bem('sub-text')
    }, text);
  });
};
var SelectPlanForm = function SelectPlanForm(_ref) {
  var defaultValues = _ref.defaultValues,
    products = _ref.products,
    onSubmit = _ref.onSubmit;
  return /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Form, {
    className: BLOCK_CLASS,
    defaultValues: defaultValues,
    onSubmit: onSubmit
  }, function (_ref2, Controller) {
    var control = _ref2.control,
      formState = _ref2.formState,
      watch = _ref2.watch;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Controller, {
      name: "selectedOffer",
      control: control,
      render: function render(_ref3) {
        var field = _ref3.field;
        return /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.ProductList, Object.assign({
          css: {
            marginLeft: 'auto',
            marginRight: 'auto'
          },
          products: products.map(function (product) {
            return _objectSpread(_objectSpread({}, product), {}, {
              offerItems: product.offerItems.map(function (offer) {
                var selectedOfferId = watch('selectedOffer').split('-')[1];
                return _objectSpread(_objectSpread({}, offer), {}, {
                  cardCss: _objectSpread(_objectSpread({}, offer.cardCss), {}, {
                    boxShadow: String(offer.id) === selectedOfferId ? '0px 0px 10px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.15)' : 'none'
                  })
                });
              })
            });
          })
        }, field));
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: bem('cta')
    }, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Button.Primary, {
      disabled: !formState.isDirty && !defaultValues.selectedOffer,
      type: "submit",
      id: "select-offer"
    }, "Continue"), renderSubText(watch('selectedOffer'))));
  });
};
SelectPlanForm.propTypes = {
  defaultValues: _propTypes.default.shape({
    selectedOffer: _propTypes.default.string
  }).isRequired,
  products: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    content: _propTypes.default.element
  })).isRequired,
  onSubmit: _propTypes.default.func.isRequired
};
var _default = exports.default = SelectPlanForm;
